 import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify' 
import ByModalComponent from '@/components/Shared/BuyModal'
import * as fb from 'firebase'
import './stylus/main.styl'
 

 

Vue.component('app-buy-modal', ByModalComponent)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  created () {
  	 
  	fb.initializeApp({
  		apiKey: 'AIzaSyBM8Ut5MPwdlHgqWHLApYQA3RoZK1Iyo2g',
    authDomain: 'v-11-d4095.firebaseapp.com',
    databaseURL: 'https://v-11-d4095.firebaseio.com',
    projectId: 'v-11-d4095',
    storageBucket: 'v-11-d4095.appspot.com',

    messagingSenderId: '841351857886',
    appId: '1:841351857886:web:98f75851b6bbde5752644f',
    measurementId: 'G-5XLY4GJL3J'
  	}) 
    

  	fb.auth().onAuthStateChanged(user=>{
  		if (user) {
  			this.$store.dispatch('autoLoginUser', user)
  		}
  	})  //обратились к модулю отвечающему за авторизацию

    this.$store.dispatch('fetchAds')
    // обратились к актиону fethAds


  },
  render: h => h(App)
}).$mount('#app')
